import { renderState } from "../../../../core/js/state-machine";

/**
 * Creates the Cell Component
 * @param {HTMLElement} element
 * @param {Object} config
 * @returns {{
 * dispose:Function,
 * cellProps:Object,
 * data:*
 * }}
 */
const Cell = (element, { data, columnProps, cellProps }) => {
    const columnClassName = columnProps.colClass;

    /**
     * Update cell with new content
     * @param {Object} data
     * @param {{row:Number:col:Number}} cellProps
     */
    const update = (cellData, cellProps) => {
        columnProps.render(element, cellData, { columnProps, cellProps });
        api.data = cellData;
        api.cellProps = cellProps;
    };

    if (element) {
        renderState({ classList: [columnClassName] }, element.parentNode);
    }

    const api = {
        element,
        update,
        cellProps,
        data,
    };
    return api;
};

export default Cell;
